import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { DashboardPage } from './../../../../providers/bridge-api/dashboard.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-dashboard-page-reorder-dialog',
  templateUrl: './dashboard-page-reorder-dialog.component.html',
  styleUrls: ['./dashboard-page-reorder-dialog.component.scss'],
  standalone: false,
})
export class DashboardPageReorderDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() pages: DashboardPage[];

  @Output() modalClosed = new EventEmitter<DashboardPage[]>();

  sortOrder: DashboardPage[];

  constructor() {}

  ngOnInit(): void {
    this.sortOrder = [...this.pages];
  }

  onItemsReordered($event) {
    moveItemInArray(this.sortOrder, $event.previousIndex, $event.currentIndex);
  }

  cancel() {
    this.modalClosed.emit();
  }

  save() {
    this.modalClosed.emit(this.sortOrder);
  }
}
